<template>
  <div class="relative min-w-[14px] rounded-full transition-all overflow-auto">
    <svg class="size-full -rotate-90" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
      <!-- Background Circle -->
      <circle
        cx="18"
        cy="18"
        :r="radius"
        fill="none"
        class="stroke-current text-gray-100"
        :class="classBackground"
        :stroke-width="width"
        />
      <!-- Progress Circle -->
      <circle
        cx="18"
        cy="18"
        :r="radius"
        fill="none"
        class="stroke-current text-blue-600/80"
        :class="classStroke"
        :stroke-width="width"
        stroke-dasharray="100"
        :stroke-dashoffset="computedProgress"
        stroke-linecap="round"
        />
    </svg>

    <!-- Percentage Text -->
    <div class="absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2">
      <span
        v-if="unit"
        class="text-center text-2xl font-bold text-blue-600"
        :class="classText"
        v-text="modelValue +' '+ unit"
        />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
	unit?: string
	radius?: string|number
	width?: string|number
	classStroke?: string
	classBackground?: string
	classText?: string
	duration?: string|number
}>(),{
  unit: '',
  radius: 16,
  width: 2,
  duration: 3000,
})

const emit = defineEmits(['full'])
const model = defineModel<string|number>()
const modelPaused = defineModel<boolean>('paused')

const mountedTime = ref()
const clock = ref()
const progress = ref(0)
const elapsed = ref(0)
const pauseStarted = ref()

onMounted(() => {
  mountedTime.value = Date.now()
  clock.value = setInterval(updateProgress, (16 / model.value))
})

onUnmounted(() => {
  clearInterval(clock.value)
})

const computedProgress = computed(() => {
  return 100 - progress.value
})

function updateProgress() {
  elapsed.value = Date.now() - mountedTime.value
  progress.value = Math.min((elapsed.value / props.duration) * 100, 100)
  if (progress.value >= model.value) {
    clearInterval(clock.value)
    progress.value = model.value
    emit('full', model.value)
  }
}

watch(modelPaused, (v) => {
  if (v) {
    clearInterval(clock.value)
    pauseStarted.value = Date.now()
  } else {
    mountedTime.value += Date.now() - pauseStarted.value
    clock.value = setInterval(updateProgress, (16 / model.value))
  }
})
</script>
